import * as React from 'react';

import './style.scss';

interface Props {
  message: string;
}

const ErrorMessage = (props: Props) => {
  return(
    <div className='error-message-container d-flex justify-center align-center'>
      <span className='error-message'>{props.message || null}</span>
    </div>
  );
};

export default ErrorMessage;